import { apiClient } from '@/shared/lib/axios';
import { BankType } from '@/types/admin-clinic-info';
import { useQuery } from '@tanstack/react-query';

type Response<T> = {
  data: T[];
};

export const getBankType = async (siteType: string | null): Promise<Response<BankType>> => {
  const response = await apiClient.get<Response<BankType>>(
    `/admin/${siteType}/master-data/bank-types`
  );
  return response.data;
};

export const useAdminBankType = (siteType: string | null) => {
  return useQuery({
    queryKey: ['bank-types', siteType],
    queryFn: () => getBankType(siteType),
  });
};
